import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { Avatar } from "./UserAvatarView.styles";
import { colors } from "healthex-common/colors";
import { filterNull, willNeverHappen } from "healthex-common/utils";
import { fontSizes } from "healthex-common/sizes";
export var UserAvatarViewSize;
(function (UserAvatarViewSize) {
    UserAvatarViewSize["TINY"] = "TINY";
    UserAvatarViewSize["SMALL"] = "SMALL";
    UserAvatarViewSize["MEDIUM"] = "MEDIUM";
    UserAvatarViewSize["LARGE"] = "LARGE";
})(UserAvatarViewSize || (UserAvatarViewSize = {}));
export const UserAvatarView = observer((props) => {
    var _a, _b, _c, _d;
    const sizeInfo = getSizeInfo((_a = props.size) !== null && _a !== void 0 ? _a : UserAvatarViewSize.SMALL);
    const localAvataUrl = ((_b = props.user) === null || _b === void 0 ? void 0 : _b.localAvatarFile) ? URL.createObjectURL(props.user.localAvatarFile) : null;
    return (_jsx(Avatar, { src: (_d = localAvataUrl !== null && localAvataUrl !== void 0 ? localAvataUrl : (_c = props.user) === null || _c === void 0 ? void 0 : _c.avatarUrl) !== null && _d !== void 0 ? _d : undefined, dimensions: sizeInfo.dimensions, fontSize: sizeInfo.fontSize, color: props.user ? avatarColor(props.user) : "", onClick: props.onClick, disabled: props.disabled, children: props.user && getUserInitials(props.user) }));
    function avatarColor(user, disabled) {
        if (props.disabled)
            return colors.black_30;
        const accentColors = [colors.accents_sunset, colors.accents_salmon, colors.accents_grass, colors.accents_sky, colors.accents_lilac];
        return accentColors[Number(`0x${user.id.slice(-2)}`) % accentColors.length];
    }
    function getUserInitials(user) {
        const parts = filterNull([user.firstName, user.lastName]);
        if (parts.length === 0) {
            return null;
        }
        else if (parts.length === 1) {
            return parts[0].charAt(0).toUpperCase();
        }
        else {
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
        }
    }
    function getSizeInfo(size) {
        switch (size) {
            case UserAvatarViewSize.TINY:
                return { dimensions: 24, fontSize: fontSizes.TINY };
            case UserAvatarViewSize.SMALL:
                return { dimensions: 32, fontSize: fontSizes.SMALL };
            case UserAvatarViewSize.MEDIUM:
                return { dimensions: 40, fontSize: fontSizes.MEDIUM };
            case UserAvatarViewSize.LARGE:
                return { dimensions: 80, fontSize: fontSizes.LARGE };
        }
        return willNeverHappen(size);
    }
});
